import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, theme } from "antd";
import { __, _i } from "../../../utils/i18n.js";
const BillingAddressRestrictions = ()=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("hr", {
                className: "rc-account-v2-info-card-divider"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "rc-account-v2-info-card-para",
                style: {
                    color: token.colorTextSecondary
                },
                children: __("There are a few things that cannot be changed:")
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "rc-account-v2-info-card-list",
                style: {
                    color: token.colorTextSecondary
                },
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        children: _i(__("Your VAT number can only be updated on request. {{link}}Open support ticket{{/link}}"), {
                            link: /*#__PURE__*/ _jsx(Typography.Link, {
                                href: __("https://devowl.io/support/"),
                                target: "_blank",
                                rel: "noreferrer",
                                style: {
                                    fontSize: "inherit"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: __("Moving a subscription to another country is not possible for tax reasons, whether the recipient is a company/organization or a private individual.")
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: __("Subscriptions purchased as a company/organization cannot be transferred to a private individual.")
                    })
                ]
            })
        ]
    });
};
export { BillingAddressRestrictions };
